/* eslint-disable global-require */
const dynamicMiddlewares = {};

// `require` in every file except index.js from the current directory, then
// add their default export to module.exports based on their filename.
// eg dynamicMiddlewares["dynamicMiddleware"] = require("./dynamicMiddleware.js");
const req = require.context('.', false, /Middleware\.js$/);
req.keys().forEach(fileName => {
  const exportName = fileName.replace('./', '').replace('.js', '');
  dynamicMiddlewares[exportName] = req(fileName).default;
});

export { dynamicMiddlewares };
